export const main = {
  display: "flex",
  justifyContent: "center",
};
export const headerContainer = {
  margin: "3rem 3rem auto",
  padding: "1rem",
  minWidth: "400px",
  borderRadius: "2rem",
};

export const taskListLi = {
  listStyleType: "none",
};
